module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leadership"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.headingtext)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row no-margin"
  }, _vm._l((_vm.persons), function(person) {
    return _c('div', {
      staticClass: "person"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": person.image.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name))]), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [_vm._v(_vm._s(person.status))]), _vm._v(" "), _c('ul', {
      staticClass: "socials-light"
    }, [(person.social_media.link_to_facebook) ? _c('li', [_c('a', {
      attrs: {
        "href": person.social_media.link_to_facebook
      }
    }, [_c('div', {
      staticClass: "fb-icon"
    })])]) : _vm._e(), _vm._v(" "), (person.social_media.link_to_twitter) ? _c('li', [_c('a', {
      attrs: {
        "href": person.social_media.link_to_twitter
      }
    }, [_c('div', {
      staticClass: "tw-icon"
    })])]) : _vm._e(), _vm._v(" "), (person.social_media.link_to_linkedin) ? _c('li', [_c('a', {
      attrs: {
        "href": person.social_media.link_to_linkedin
      }
    }, [_c('div', {
      staticClass: "in-icon"
    })])]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.button) ? _c('div', {
    staticClass: "button"
  }, [_c('a', {
    staticClass: "btn default white",
    attrs: {
      "href": _vm.button_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.button_title)
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e90840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockLeadership.vue
// module id = 350
// module chunks = 0